const base = {
    // Header
    classroom_list: "Sınıf Listesi",
    logout: "Çıkış Yap",
    // Footer
    copyright: "Telif Hakkı",
    all_rights_reserved: "Tüm hakları saklıdır",
    privacy_policy: "Gizlilik Politikası",
    // Sidebar
    main_menu: "Ana Menü",
    account_settings: "Hesap Ayarları",
    settings: "Ayarlar",
    Courses: "Kurslar",
    dashboard: "Kurs Paneli",
    Contents: "İçerikler",
    Students: "Öğrenciler",
    Assignments: "Atamalar",
    "Live Sessions": "Canlı Dersler",

    // Student Detail
    student_details: "Öğrenci Bilgileri",
    back_to_list: "Listeye dön",
    contact_details: "Contact Details",
    email: "E-posta",
    phone: "Telefon",

    //Portfolios
    portfolios: "Portfolyolar",
    portfolio_details: "Portfolyo Bilgileri",
    add_portfolio: "Portfolyo Ekle",
    edit_portfolio: "Portfolyoyu Düzenle",
    update_portfolio: "Portfolyoyu Güncelle",
    delete_confirm_title: "Portfolyoyu Sil",
    delete_confirm_detail: ":date_field tarihinde oluşturulan portfolyoyu silmek istediğine emin misin?",
    cancel: "İptal et",
    confirm_delete: "Evet, sil",
    deleting: "Siliniyor...",
    view_details: "İçeriği Görüntüle",
    successfully_created_portfolio: "Portfolyo başarıyla oluşturuldu.",
    successfully_updated_portfolio: "Portfolyo başarıyla güncellendi.",
    successfully_deleted_portfolio: "Portfolyo başarıyla silindi.",
    failed_fetch_portfolios: "Portfolyolar getirilirken bir hata oluştu.",
    failed_delete_portfolio: "Portfolyo silinirken bir hata oluştu.",
    required_field: ":input_field doldurulması zorunlu bir alandır.",
    attendance: "Devamlılık",
    participation: "Derse Katılım",
    homework: "Ödev",
    documents: "Evraklar",
    concentration: "Konsantrasyon",
    homework_description: "Ödev Açıklaması",
    enter_homework_details: "Ödev ile alakalı detayları giriniz...",
    student_note: "Öğrenciye Not",
    parent_note: "Veliye Not",
    manager_note: "Kurum Yöneticisine Not",
    enter_note: "Not giriniz...",
    saving: "Kaydediliyor...",
    no_content: "İçerik girilmedi.",
    close: "Kapat"

}
export default base
